import LinkToCustomScriptDoc from '../links/LinkToCustomScriptDoc'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'

const CustomScript = () =>
  <div className='grid gap-4'>
    <div className='grid gap-3'>
      <Header
        hasNoTopMargin
        lessWeight
        rank={3}
      >
        Custom scripts
      </Header>
      <Paragraph>
        <strong>
          <Color variant='theme-description-text'>
            Custom scripts allow you to run a file on the execution environment before a test config run. They can execute any necessary Git commands to prepare the system, initialize data, set the system to a known state, or integrate with other version control systems.
          </Color>
        </strong>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToCustomScriptDoc />
    </Paragraph>
  </div>

export default CustomScript
